import { useEffect, useState } from 'react';
import { flightsApi } from '../api/flights.api';
import { hotelsApi } from '../api/hotels.api';
import { bookingsApi } from '../api/bookings.api';
import { reservationGroups, type ReservationGroups } from '../utils/reservations';

/**
 * The trip's reservations as expense-link options. Skips the fetch when the
 * caller already has them (the bookings tab), so it only costs requests where
 * nothing else loaded them.
 */
export function useTripReservations(tripId: string, preloaded?: ReservationGroups): ReservationGroups | null {
  const [loaded, setLoaded] = useState<ReservationGroups | null>(null);

  useEffect(() => {
    if (preloaded) return;
    let cancelled = false;
    Promise.all([flightsApi.list(tripId), hotelsApi.list(tripId), bookingsApi.list(tripId)])
      .then(([f, h, b]) => { if (!cancelled) setLoaded(reservationGroups(f, h, b)); })
      // Linking is optional: without the list the form still saves the expense.
      .catch(() => { if (!cancelled) setLoaded(null); });
    return () => { cancelled = true; };
  }, [tripId, preloaded]);

  return preloaded ?? loaded;
}
